import type { WalletKind } from './wallet';

/**
 * Session persistence. The backend issues a stateless HMAC **Bearer** token
 * (auth/session.ts), so — consistent with that design — we keep it in localStorage
 * and attach it as `Authorization: Bearer`. No cookies, no refresh flow at v1.
 */

const STORAGE_KEY = 'gravelight.session';

export interface StoredSession {
  token: string;
  accountId: string;
  walletKind: WalletKind;
  walletAddress: string;
}

export function loadSession(storage: Storage = localStorage): StoredSession | null {
  const raw = storage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<StoredSession>;
    if (parsed.token && parsed.accountId && parsed.walletKind && parsed.walletAddress) {
      return parsed as StoredSession;
    }
  } catch {
    // ignore corrupt entry
  }
  return null;
}

export function saveSession(session: StoredSession, storage: Storage = localStorage): void {
  storage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearSession(storage: Storage = localStorage): void {
  storage.removeItem(STORAGE_KEY);
}
